import React, { useState, useEffect, useRef } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/private-notices/PrivateNoticesAction";
import { BackwardButton, ForwardButton, noReceipentAlert, noReceipentTypeAlert, NoticeReceipentType, redirectToPages, resultAlert } from "../../../../../../_helpers/Helpers";
import { useSubheader } from "../../../../../../_metronic/layout";
import { 
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { PrivateNoticeAddForm } from "./PrivateNoticeAddForm";
import { TeachersPage } from "./teachers/TeachersPage";
import { ParentsPage } from "./parents/ParentsPage";
import { StudentsPage } from "./students/StudentsPage";
import { SectionsPage } from "./sections/SectionsPage";

export function PrivateNoticeAdd({
  history
}) {
  // Subheader
  const subheader = useSubheader();
  const [title, setTitle] = useState("");
  const [eventKey, setEventKey] = useState("first");
  const [receipentIds, setReceipentIds] = useState();
  const [receipentType, setReceipentType] = useState();
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, privateNotice } = useSelector(
    (state) => ({
      actionsLoading: state.privateNotices.actionsLoading,
      isSuccess: state.privateNotices.isSuccess,
      type: state.privateNotices.type,
      privateNotice: state.privateNotices.privateNotice
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getNewPrivateNotice());
    return () => dispatch(actions.cleanPrivateNoticesState());
  }, [dispatch]);
  
  useEffect(() => {
    let _title = "Özel Duyuru Ekle";
    setTitle(_title);
    subheader.setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subheader]);

  /** İleri İşlemini İfade Eder */
  const forward = () => {
    if (receipentType === null || receipentType === undefined) {
      noReceipentTypeAlert();
      return;
    }
    if (!receipentIds || receipentIds.length < 1) {
      noReceipentAlert();
      return;
    }
    setEventKey("second");
  }

  /** Geri İşlemini İfade Eder */
  const backward = () => {
    setEventKey("first");
  }

  /** Belli Bir Özel Duyuruyu Kaydeder */
  const savePrivateNotice = (values) => {
    values.receipentIds = receipentIds;
    values.receipentType = receipentType;
    const formData = new FormData();
    formData.append("fileData", values.attachment);
    formData.append("serializedData", JSON.stringify(values));
    dispatch(actions.savePrivateNotice(formData)).then((result) => onResult(result));
  };
  
  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push(`/ozel-duyurular`), 2500);
  };

  const btnRef = useRef();  
  const savePrivateNoticeClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  return (
    <>
      <Card>
        {actionsLoading && <ModalProgressBar />}
        <CardHeader title={title}>
          <CardHeaderToolbar>
            {
              eventKey === "first" &&
              <ForwardButton
                method={forward}
              />
            }
            {
              eventKey === "second" &&
              <BackwardButton
                method={backward}
              />
            }
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <div className="mt-5">
            <PrivateNoticeAddForm
              eventKey={eventKey}
              privateNotice={privateNotice}
              btnRef={btnRef}              
              setReceipentType={setReceipentType}
              savePrivateNotice={savePrivateNotice}
            />
          </div>
        </CardBody>
        {
          eventKey === "second" &&
          <CardFooter>        
            <div className="offset-sm-2">
              <button
                type="submit"
                className="btn btn-primary"
                onClick={savePrivateNoticeClick}
              >
                Gönder
              </button>
            </div>
          </CardFooter>
        }
      </Card>
      {
        eventKey === "first" && receipentType === NoticeReceipentType.Teacher &&
        <TeachersPage
          setReceipentIds={setReceipentIds}
        />
      }
      {
        eventKey === "first" && (receipentType === NoticeReceipentType.Parent || receipentType === NoticeReceipentType.Father || receipentType === NoticeReceipentType.Mother) &&
        <ParentsPage
          receipentType={receipentType}
          setReceipentIds={setReceipentIds}
        />
      }
      {
        eventKey === "first" && receipentType === NoticeReceipentType.Student &&
        <StudentsPage          
          setReceipentIds={setReceipentIds}
        />
      }
      {
        eventKey === "first" && receipentType === NoticeReceipentType.Section &&
        <SectionsPage          
          setReceipentIds={setReceipentIds}
        />
      }
    </>
  );
}